import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logged-out-overlay" }

import { useLogInOut } from '@exchange/libs/auth/ui/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoggedOutOverlay',
  props: {
  showSpinner: { type: Boolean, default: false },
},
  setup(__props) {



const { isXS } = useMQBreakpoints();
const { signup, login } = useLogInOut();

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_ot_spinner = _resolveComponent("ot-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.showSpinner)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_x_button, {
            class: "logged-out-overlay__login",
            variant: "primary",
            text: _ctx.$t('modules.login.navBarLoginButtonText'),
            onClick: _unref(login)
          }, null, 8, ["text", "onClick"]),
          _createVNode(_component_x_button, {
            class: "logged-out-overlay__signup",
            variant: "outline",
            text: _ctx.$t('modules.login.formOverlaySignupButtonText'),
            onClick: _unref(signup)
          }, null, 8, ["text", "onClick"])
        ], 64))
      : (_openBlock(), _createBlock(_component_ot_spinner, {
          key: 1,
          class: "logged-out-overlay__spinner"
        }))
  ]))
}
}

})